export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20dreamy%20abstract%20background%20with%20gentle%20pastel%20gradients%20of%20warm%20pink%20cream%20and%20peach%20tones%2C%20delicate%20blurry%20shapes%2C%20peaceful%20and%20calming%20atmosphere%2C%20minimalist%20aesthetic%2C%20soft%20light&width=1800&height=600&seq=cta-bg-2025&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-black/15"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
          每一位哺乳妈妈都值得被温柔以待
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 leading-relaxed">
          无论你正在经历哺乳的哪个阶段，奶水漫画都愿做你育儿路上最温暖的陪伴。
          每周更新原创漫画，订阅不错过每一篇好内容。
        </p>
        <a
          href="#newsletter"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer no-underline transition-all duration-200"
          style={{ backgroundColor: 'oklch(var(--accent-500))', color: '#fff' }}
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-mail-line text-sm"></i>
          </span>
          订阅更新通知
        </a>
      </div>
    </section>
  );
}